import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { postLoginAction } from '../redux/action/auth.action';
import { useNavigate } from 'react-router-dom';

const Login = (props) => {
  const [state, setState] = useState({
    loading: false,
    user: {
      username: '',
      password: ''
    }
  })
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const jwtToken = useSelector(state => state.auth.generateToken)
  const dispatch = useDispatch()
  const navigate = useNavigate();


  // const handleSubmit = () => {
  //   // e.preventDefault()
  //   if (state.user.username !== '' && state.user.password !== '') {
  //     setState(prevState => { return { ...prevState, loading: true } })
  //     dispatch(postLoginAction(jwtToken, state.user))
  //       .then((res) => {
  //         console.log('response login', res?.data)
  //         if (res.status === 200) {
  //           navigate('/home');
  //         } else {
  //           if(res?.data?.StatusCode === 403){
  //             alert(res?.data?.Message);
  //             // navigate('/')
  //           }
  //           // setState(prevState => { return { ...prevState, loading: false } })
  //           // return alert(res.data.message)
  //         }
  //       })
  //   } else {
  //     return alert('Username and Password required!')
  //   }
  // }

  const handleSubmit = async () => {
    if (state.user.username !== '' && state.user.password !== '') {
      setState(prevState => ({ ...prevState, loading: true }));
      try {
        const res = await dispatch(postLoginAction(jwtToken, state.user));
        console.log('response login', res?.data);
        if (res.status === 200) {
          navigate('/home');
        } else {
          alert(res?.data?.Message);
          window.location.reload();
        }
      } catch (error) {
        alert('An error occurred during login: ' + error.message);
      } finally {
        setState(prevState => ({ ...prevState, loading: false }));
      }
    } else {
      alert('Username and Password required!');
    }
  };

  const onChangeInput = event => {
    const { name, value } = event.target
    setState({
      ...state,
      user: {
        ...state.user,
        [name]: value
      }
    })
  }

  function togglePasswordVisibility() {
    setIsPasswordVisible((prevState) => !prevState)
  }
  return (
    <div className='grid w-full grid-cols-1 sm:grid-cols-2 '>
      <div className='grid content-center invisible w-full h-0 mx-auto sm:h-screen bg-gradient-to-b from-red-600 via-red-600 to-slate-900 sm:visible'>
        <div>
          <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/home-logo.svg"} className='w-full px-32' />
        </div>
      </div>
      <div className='grid content-center w-full h-screen grid-cols-1 px-4 mx-auto sm:bg-gradient-to-b sm:from-white sm:via-white sm:to-white bg-gradient-to-b from-red-600 via-red-600 to-slate-900 '>
        <div>
          <div className='text-center h-1/4'>
            <h1 className='text-4xl font-bold text-white sm:text-red-bg'>SELAMAT DATANG</h1>
            <p className='text-base text-white sm:text-black '>Semua tentang absensi, informasi dan acara </p>
          </div>
          <div>
            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/home-logo.svg"} className='w-full px-32 sm:hidden' />
          </div>


          <div className="grid grid-cols-1 pt-3 gap-x-8 gap-y-6 sm:grid-cols-2">
            <div className="sm:col-span-2">
              <label htmlFor="email" className="block text-sm font-semibold leading-6 text-white sm:text-black">
                Email
              </label>
              <div className="mt-2.5">
                <input
                  type="text"
                  name="username"
                  id="email"
                  value={state.user.username}
                  onChange={(e) => onChangeInput(e)}
                  placeholder='Email / ID Karyawan'
                  className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className='relative sm:col-span-2'>
              <label htmlFor="password" className="block text-sm font-semibold leading-6 text-white sm:text-black">
                Password
              </label>
              <input
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Masukkan Kata Sandi"
                name="password"
                id="password"
                value={state.user.password}
                onChange={(e) => onChangeInput(e)}
                autoComplete="password"
                className="w-full px-4 py-2 text-base border border-gray-300 rounded outline-none focus:ring-blue-500 focus:border-blue-500 focus:ring-1"
              />
              <button
                className="absolute right-0 flex items-center px-4 text-gray-600 bottom-3"
                onClick={togglePasswordVisibility}
              >
                {isPasswordVisible ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                )}
              </button>

            </div>
          </div>
          <div className="mt-10">
            <button
              type="button"
              onClick={handleSubmit}
              className="block w-full rounded-full bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Masuk
            </button>
            <div className='text-center '>
              <div className='pt-16 text-base text-white sm:text-black '>Lupa Sandi </div>
              <div className='pt-2 pb-4 text-base text-white sm:text-black'>Belum punya akun? <span className=' text-red-bg'>Daftar Sekarang</span></div>
            </div>

          </div>
        </div>

      </div>

    </div>
  )
}

export default Login